export const NescoBranches = [
  {
    id: "1",
    nameAr: "الرياض",
    nameEn: "Riyadh",
    center: [24.714308829721023, 46.67408631829917],
    branches: [
      {
        id: "1",
        nameAr: "العلیا",
        nameEn: "Al Olaya",
        address: "Al Olaya, Riyadh 12333, Saudi Arabia",
        hotNum: "12333",
        phone: "8007550022",
        latLang: [24.70261294219779, 46.66893647634181],
        location: "https://maps.app.goo.gl/35qdCb8dJAAECdr17",
      },
      {
        id: "2",
        nameAr: "ظھرة لبن",
        nameEn: "Dhahrat Laban",
        address: "MH25+6X8, Dhahrat Laban, Riyadh 13751, Saudi Arabia",
        address: "",
        hotNum: "13751",
        phone: "554324763",
        latLang: [24.666175202680982, 46.55716498667177],
        location: "https://maps.app.goo.gl/x52otinNvSCJuZN68"
      },
    ],
  },
  {
    id: "2",
    nameAr: "أبها",
    nameEn: "Abha",
    center: [18.246342854649495, 42.51114517267884],
    branches: [
      {
        id: "1",
        nameAr: "طریق الملك عبدالعزیز، الوردتین",
        nameEn: "King Abdul Aziz Rd, Al Wardatain",
        address: "King Abdul Aziz Rd, Al Wardatain, Abha 62521, Saudi Arabia",
        hotNum: "62521",
        phone: "554324763",
        latLang: [18.2419181677916, 42.49689185633216],
        location: "https://maps.app.goo.gl/ShsiuVg8GCRdj7QZA"
      },
      {
        id: "2",
        nameAr: "طریق الملك عبد العزیز - al sarawat",
        nameEn: "King Abdul Aziz Rd, Alsarawat",
        address: "King Abdul Aziz Rd, Alsarawat, Abha Saudi Arabia",
        hotNum: "",
        phone: "554324763",
        latLang: [18.214859929400713, 42.49690168390482],
        location: "https://maps.app.goo.gl/Ss8MgDirxH3qeydD9"
      },
      {
        id: "3",
        nameAr: "طریق الملك فھد، حي العرین",
        nameEn: "King Fahd Rd، حي العرین",
        address: "6912 King Fahd Rd, حي العرين, ABDB4710, 4710, Abha 62524, Saudi Arabia",
        hotNum: "62524",
        phone: "8007550022",
        latLang: [18.23025345509859, 42.541442613709954],
        location: "https://maps.app.goo.gl/HsSKQA2R7QwcYybB7"
      },
      {
        id: "4",
        nameAr: "طریق الملك عبدلله، الربوة",
        nameEn: "King Abdullah Rd, Al Rabwah",
        address: "King Abdullah Rd, Al Rabwah, Abha 62523, Saudi Arabia",
        hotNum: "62523",
        phone: "8007550022",
        latLang: [18.208285458598542, 42.53054029228659],
        location: "https://maps.app.goo.gl/xfCngbwtQ7Nu6D2o7"
      },
      {
        id: "5",
        nameAr: "طریق الملك فھد، البدیع، 954",
        nameEn: "طریق الملك فھد، البدیع، 954",
        address: "4863 King Fahd Rd, البديع، 9544, Abha 62581, Saudi Arabia",
        hotNum: "62581",
        phone: "554324763",
        latLang: [18.24951399765481, 42.58204010657421],
        location: "https://maps.app.goo.gl/6of4y6HfGYQEe5gz9"
      },
      {
        id: "6",
        nameAr: "Hijlah, Khamis Mushait",
        nameEn: "Hijlah, Khamis Mushait",
        address: "Hijlah, Khamis Mushait 62451, Saudi Arabia",
        hotNum: "62451",
        phone: "8007550022",
        latLang: [18.284353878286556, 42.667186952906164],
        location: "https://maps.app.goo.gl/kUJac6a3YcaVqoRXA"
      },
    ],
    
  },
  {
    id: "3",
    nameAr: "جيزان",
    nameEn: "Jizan",
    center: [16.889981138235044, 42.57040164693723],
    branches: [
      {
        id: "1",
        nameAr: "شارع المدینة المنورة، حي الشاطئ، جازان",
        nameEn: "شارع المدینة المنورة، حي الشاطئ، جازان",
        address: "7254 شارع المدينة المنورة، حي الشاطئ، جازان 82814 2303،،, Jazan 82814, Saudi Arabia",
        hotNum: "2303 82814",
        phone: "8007550022",
        latLang: [16.948081253121437, 42.5566282757066],
        location: "https://maps.app.goo.gl/oYAZeDtqqYuyAokD9"
      },
      {
        id: "2",
        nameAr: "الصفا، 82721 ، جازان",
        nameEn: "Al Safa",
        address: "Al Safa, 82721, Jazan 82842, Saudi Arabia",
        hotNum: "82842",
        phone: "8007550022",
        latLang: [16.89511209519609, 42.55820447358253],
        location: "https://maps.app.goo.gl/m1Jc46iqzrPXwvNP7"
      },
      {
        id: "3",
        nameAr: "المنطقة الصناعیة، جازان",
        nameEn: "Industrial Area, Jazan",
        address: "Industrial Area, Jazan 82621, Saudi Arabia",
        hotNum: "82621",
        phone: "554324763",
        latLang: [16.842215482325532, 42.60695630280018],
        location: "hhttps://maps.app.goo.gl/JCuZbMAP8W7RRJ3n9"
      },
      {
        id: "4",
        nameAr: "نستريتو كوفي",
        nameEn: "نستريتو كوفي",
        address: "",
        hotNum: "82621",
        phone: "554324763",
        latLang: [16.902632565028508, 42.548179237743966],
        location: "https://maps.app.goo.gl/yuPhKGu8HRezwwmR8"
      },
    ],
  },
  {
    id: "4",
    nameAr: "الدرب",
    nameEn: "Al DARB",
    center: [17.734138499024542, 42.26588763441278],
    branches: [
      {
        id: "1",
        nameAr: "GRUB2394",
        nameEn: "GRUB2394",
        address: "GRUB2394 6072 Jeddah - Abha Hwy, Ad Darb 89741, Saudi Arabia",
        hotNum: "89874",
        phone: "8007550022",
        latLang: [17.744111968579954, 42.282281295294084],
        location: "https://maps.app.goo.gl/jnGpNJDyZpTMowVV6"
      },
      {
        id: "2",
        nameAr: "ابو السداد، الدرب",
        nameEn: "Abu AlSadad, Ad Darb",
        address: "Abu AlSadad, Ad Darb 89874, Saudi Arabia",
        hotNum: "89874",
        phone: "8007550022",
        latLang: [17.723982710015335, 42.23275173151365],
        location: "https://maps.app.goo.gl/G5RKAzqH53ajEmgo6"
      },
    ],
  },
  {
    id: "5",
    nameAr: "بيش",
    nameEn: "Baish",
    center: [17.374606177332268, 42.53592167215909],
    branches: [
      {
        id: "1",
        nameAr: "البطنة",
        nameEn: "AL-BATNA",
        address: "9FM6+8W, AL-BATNA 87521, Saudi Arabia",
        hotNum: "87521",
        phone: "554324763",
        latLang: [17.38950441367524, 42.4629901047146],
        location: "https://maps.app.goo.gl/qRgnCEwnuQfw9nfS9"
      },
      {
        id: "2",
        nameAr: "المطعن",
        nameEn: "Al-Matan",
        address: "CGHJ+7C, Al-Matan 87515, Saudi Arabia",
        hotNum: "87515",
        phone: "554324763",
        latLang: [17.429877475505705, 42.530715107168064],
        location: "https://maps.app.goo.gl/JKSij21oSHHkrkREA"
      },
    ],
  },
  {
    id: "6",
    nameAr: "صبيا",
    nameEn: "Sabya",
    center: [17.15538572391517, 42.62669358074856],
    branches: [
      {
        id: "1",
        nameAr: "King Abdul Aziz Rd Sabya، جازان 85298",
        nameEn: "King Abdul Aziz Rd Sabya، جازان 85298",
        address: "King Abdul Aziz Rd Sabya، جازان 85298, Saudi Arabia",
        hotNum: "85298",
        phone: "8007550022",
        latLang: [17.145935670454794, 42.644886071164336],
        location: "https://maps.app.goo.gl/ex26wDoz1jjA8Wud7"
      },
    ],
  },
  {
    id: "7",
    nameAr: "خميس مشيط",
    nameEn: "Khamis Mushait",
    center: [18.30857195264389, 42.764863479066996],
    branches: [
      {
        id: "1",
        nameAr: "طریق المحالة، القافلة، خمیس مشیط",
        nameEn: "Al Mahalah Rd, Al Qafilah, Khamis Mushait",
        address: "Al Mahalah Rd, Al Qafilah, Khamis Mushait 62454, Saudi Arabia",
        hotNum: "62454",
        phone: "554324763",
        latLang: [18.331351253021793, 42.69448195667305],
        location: "https://maps.app.goo.gl/xLSL5fM6LZQpsWWDA"
      },
      {
        id: "2",
        nameAr: "سعد بن ابي وقاص، الرصراص، خمیس مشیط",
        nameEn: "Sad Ibn Abi Waqas, Al Rasras, Khamis Mushait",
        address: "Sad Ibn Abi Waqas, Al Rasras, Khamis Mushait 62441, Saudi Arabia",
        hotNum: "62441",
        phone: "8007550022",
        latLang: [18.261964687022367, 42.78648956731294],
        location: "https://maps.app.goo.gl/zqHxVmdwWJFjZXDu5"
      },
      {
        id: "3",
        nameAr: "حجله، خمیس مشیط",
        nameEn: "Hijlah, Khamis Mushait",
        address: "Hijlah, Khamis Mushait 62451, Saudi Arabia",
        hotNum: "62451",
        phone: "8007550022",
        latLang: [18.282970349644913, 42.66529808171589],
        location: "https://maps.app.goo.gl/cpZ27LNiAix3CcAx5"
      },
      {
        id: "4",
        nameAr: "Al Madina Al Askariya Road, خمیس مشیط",
        nameEn: "Al Madina Al Askariya Road, Khamis Mushait",
        address: "Al Madina Al Askariya Road, Khamis Mushait Saudi Arabia",
        hotNum: "",
        phone: "554324763",
        latLang: [18.263480239280792, 42.754906038095065],
        location: "https://maps.app.goo.gl/1BgnbEwDeYS1j9898"
      },
      {
        id: "5",
        nameAr: "طریق الملك عبدلله، قرى آل غلیظ، خمیس مشیط",
        nameEn: "King Abdullah Rd, Sirr ad Ghalidh, Khamis Mushait",
        address: "King Abdullah Rd, Sirr ad Ghalidh, Khamis Mushait 62589, Saudi Arabia",
        hotNum: "62589",
        phone: "554324763",
        latLang: [18.194780466961475, 42.655000201956774],
        location: "https://maps.app.goo.gl/UFQBm1arvMUCsKoT9"
      },
      {
        id: "6",
        nameAr: "طریق الأمیر سلطان، الشفاء، خمیس مشیط",
        nameEn: "Prince Sultan Rd, Al Shifa, Khamis Mushait",
        address: "Prince Sultan Rd, Al Shifa, Khamis Mushait 62433, Saudi Arabia",
        hotNum: "62433",
        phone: "554324763",
        latLang: [18.284380010338342, 42.722290738196975],
        location: "https://maps.app.goo.gl/8QUtQTzSQWg1aNBo6"
      },
      {
        id: "7",
        nameAr: "طریق تندحة، الموسى، خمیس مشیط",
        nameEn: "طريق تندحة, Al Mossa, Khamis Mushait",
        address: "طريق تندحة, Al Mossa, Khamis Mushait 62454, Saudi Arabia",
        hotNum: "62454",
        phone: "554324763",
        latLang: [18.33276940454401, 42.756621209829966],
        location: "https://maps.app.goo.gl/oszJ9UYZbgutk6aN7"
      },
      {
        id: "8",
        nameAr: "الربیع، خمیس مشیط",
        nameEn: "Ar Rabie, Khamis Mushait",
        address: "Ar Rabie, Khamis Mushait 62454, Saudi Arabia",
        hotNum: "62454",
        phone: "554324763",
        latLang: [18.311875467178908, 42.69310614225963],
        location: "https://maps.app.goo.gl/K9ib9XKXJDpFVdRh6"
      },
      {
        id: "9",
        nameAr: "طريق الأمير سلطان، ضمك",
        nameEn: "طريق الأمير سلطان، ضمك , Abha",
        address: "طريق الأمير سلطان، ضمك 62438،, Abha 62438, Saudi Arabia",
        hotNum: "62438،",
        phone: "554324763",
        latLang: [18.246816773907288, 42.68212125651618],
        location: "https://maps.app.goo.gl/Fn9R66saW9J9aJwP7"
      },
    ],
  },
  {
    id: "8",
    nameAr: "أحد رفيدة",
    nameEn: "Ahad Rafidah",
    center: [18.19572223996049, 42.81997078301961],
    branches: [
      {
        id: "1",
        nameAr: "الرونة، أحد رفیدة",
        nameEn: "Al Laith Road, Al Runah, Ahad Rafidah",
        address: "Al Laith Road, Al Runah, Ahad Rafidah 67397, Saudi Arabia",
        hotNum: "67397",
        phone: "554324763",
        latLang: [18.222084181289947, 42.82597919922379],
        location: "https://maps.app.goo.gl/wqV4NezEypkujbzG9"
      },
      {
        id: "2",
        nameAr: "العزیزیة، أحد رفیدة",
        nameEn: "Al Aziziyyah, Ahad Rafidah",
        address: "Al Aziziyyah, Ahad Rafidah 62238, Saudi Arabia",
        hotNum: "62238",
        phone: "554324763",
        latLang: [18.16699562774276, 42.810614968538545],
        location: "https://maps.app.goo.gl/Mj8W7fSc49CyPUNw9"
      },
    ],
  },
  {
    id: "9",
    nameAr: "بيشة - الكبیرة",
    nameEn: "Bishah",
    center: [19.976364116948883, 42.589919881379984],
    branches: [
      {
        id: "1",
        nameAr: "النخیل، بیشة",
        nameEn: "Al Nakhil, Bisha",
        address: "Al Nakhil, Bisha 67716, Saudi Arabia",
        hotNum: "67716",
        phone: "554324763",
        latLang: [20.026297180094204, 42.610014936897805],
        location: "https://maps.app.goo.gl/KfHwKASAkqa2MS9M7"
      },
      {
        id: "2",
        nameAr: "التضامن، بیشة",
        nameEn: "Altdhamun, Bisha",
        address: "Altdhamun, Bisha 67911, Saudi Arabia",
        hotNum: "67911",
        phone: "554324763",
        latLang: [20.050807919908202, 42.58259552118853],
        location: "https://maps.app.goo.gl/L3bX2kUNc2b4XCVz7"
      },
      {
        id: "3",
        nameAr: "طریق الملك خالد، الخزامى، بیشة",
        nameEn: "King Khalid Rd, Alkhuzama, Bisha",
        address: "King Khalid Rd, Alkhuzama, Bisha 67711, Saudi Arabia",
        hotNum: "67711",
        phone: "554324763",
        latLang: [20.012910207368265, 42.60692503222908],
        location: "https://maps.app.goo.gl/oPdfs5jHL8AWaFHRA"
      },
      {
        id: "4",
        nameAr: "الامیر سلطان، بیشة",
        nameEn: "Alamir Sultan, Bisha",
        address: "Alamir Sultan, Bisha 67721, Saudi Arabia",
        hotNum: "67721",
        phone: "8007550022",
        latLang: [19.95501099530802, 42.6049402757066],
        location: "https://maps.app.goo.gl/JoipVzLcRzQF5zCe6"
      },
    ],
  }
];